import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttachmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attachment"}/>
}
